import React from 'react';
import getCountryFlag from 'src/utils/countries-flags';
import { CountryWithStatus } from 'src/dtos/country-with-status.dto';
import { Toggle } from '../../../shared/toggle/toggle';
import { useStores } from '../../../store';
import './country-row.scss';
import { BlockDirectionType } from '../../../../utils/enums';
import { Tooltip } from 'antd';
import { observer } from 'mobx-react-lite';

interface CountryRowProps {
    countryWithStatus: CountryWithStatus;
    isOutboundAllow: boolean;
    isInboundAllow: boolean;
    onChange: (val: boolean, direction: BlockDirectionType, countryCode: string, countryName: string) => void;
}

export const CountryRow: React.FC<CountryRowProps> = observer(({ countryWithStatus, isInboundAllow, isOutboundAllow, onChange }) => {
    const { fwVersionStore } = useStores();
    const { countryCode, countryName } = countryWithStatus;

    const countryNameAndFlag = () => {
        const FlagSvg = getCountryFlag(countryCode);
        return <div className="flag-and-name">
            <div className="flag">{FlagSvg && <FlagSvg />}</div>
            <div className="country-name"><Tooltip title={countryName}>{countryName}</Tooltip></div>
        </div>;
    };

    return <div className="country-row card" key={countryCode}>
        {countryNameAndFlag()}
        <div className="toggle-buttons">
            <Toggle value={isInboundAllow}
                disableReason={fwVersionStore.getDisableReason}
                onChange={(isBlock: boolean) => onChange(isBlock, BlockDirectionType.IS_INBOUND, countryCode, countryName)}
                withIcon={true} />
            <Toggle value={isOutboundAllow}
                    disableReason={fwVersionStore.getDisableReason}
                    onChange={(isBlock: boolean) => onChange(isBlock, BlockDirectionType.IS_OUTBOUND, countryCode, countryName)}
                    withIcon={true} />
        </div>
    </div>;
});
